const AbstractDojoRequestRecord = require('./AbstractDojoRequestRecord');
const DojoConfig = require('../../DojoConfig');
const DojoReportType = require('@/lib/PaymentMethods/Dojo/DojoReportType');

/**
 * Make a request to start the report for the terminal specified by the terminalId.
 */
class DojoTerminalReportRequestRecord extends AbstractDojoRequestRecord {
    /**
     * @param {DojoConfig} config
     * @param {DojoReportType} reportType
     */
    constructor(config, reportType) {
        if (!(config instanceof DojoConfig)) {
            throw new Error('Required instance of DojoConfig is missing');
        }

        if (!Object.values(DojoReportType).includes(reportType)) {
            throw new Error('DojoReportType is missing');
        }

        const url = 'pac/terminals/' + config.terminalId + '/reports';
        super(
            'POST',
            url
        );
        this.data = {
            reportType,
        };
    }
}

module.exports = DojoTerminalReportRequestRecord;
